import React, { useEffect } from 'react';
import { useGlobalContext } from "../context/GlobalContext";
import data from '../data/video'

export const Video = () => {
  const { setLightTheme } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true)
  }, [])

  const videos = data.videos.map((item, i) => (
    <div className="b-video__container">
      <div className="b-video__iframe-box">
        <iframe className="lazyload b-video__iframe" src={item.link} title={item.title}
          frameborder="0" webkitallowfullscreen mozallowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div className="b-video__text">
        <h4 className="b-video__title">{item.title}</h4>
        <div className="b-video__subtitle">{item.subtitle}</div>
        {(item.music) ? (<p>music by: {item.music}</p>) : null}
        <p>edited and produced by: {item.edited}</p>
      </div>
    </div>
  ))

  return (
    <React.Fragment>
      <div className="b-video l-container">
        {videos}
      </div>
    </React.Fragment>
  )
}